import type { ListAudienceUsersQuery, ListAudiencesQuery } from '~/services/PromoService';

export const audienceQueryKeys = {
  all: ['audiences'] as const,
  lists: () => [...audienceQueryKeys.all, 'list'] as const,
  list: (query: ListAudiencesQuery) => [...audienceQueryKeys.lists(), query] as const,
};

export const audienceUserQueryKeys = {
  all: ['audience-users'] as const,
  lists: () => [...audienceUserQueryKeys.all, 'list'] as const,
  list: (query: ListAudienceUsersQuery) => [...audienceUserQueryKeys.lists(), query] as const,
};
